import React from "react";

// Decorative artwork per theme key (see lib/offers/offerTheme.js). Purely
// visual: always aria-hidden, and themes without an entry render nothing.

const Sparkle = ({ x, y, size, delay, color }) => (
  <path
    className="pb-offer-sparkle"
    style={{ animationDelay: delay }}
    d={`M${x} ${y - size} L${x + size * 0.28} ${y - size * 0.28} L${x + size} ${y} L${x + size * 0.28} ${y + size * 0.28} L${x} ${y + size} L${x - size * 0.28} ${y + size * 0.28} L${x - size} ${y} L${x - size * 0.28} ${y - size * 0.28} Z`}
    fill={color}
  />
);

const RANGOLI_PETALS = Array.from({ length: 12 }, (_, index) => index * 30);

const DiyaRangoliArtwork = ({ accent, accentSoft }) => (
  <svg viewBox="0 0 220 160" className="h-full w-full" fill="none">
    {/* Rangoli */}
    <g transform="translate(150 80)" opacity="0.5">
      <circle r="62" stroke={accentSoft} strokeWidth="1.5" strokeDasharray="3 5" />
      {RANGOLI_PETALS.map((angle) => (
        <path
          key={angle}
          transform={`rotate(${angle})`}
          d="M0 -18 C 10 -30, 10 -44, 0 -54 C -10 -44, -10 -30, 0 -18 Z"
          stroke={accent}
          strokeWidth="1.5"
          fill={angle % 60 === 0 ? accent : "none"}
          fillOpacity="0.25"
        />
      ))}
      <circle r="14" fill={accent} fillOpacity="0.35" stroke={accentSoft} strokeWidth="1.5" />
      <circle r="5" fill={accentSoft} />
    </g>

    {/* Diya */}
    <g transform="translate(64 96)">
      <ellipse cx="0" cy="34" rx="40" ry="5" fill="#000" opacity="0.2" />
      <path d="M-42 6 C -36 30, 36 30, 42 6 Z" fill={accent} />
      <path d="M-42 6 C -30 14, 30 14, 42 6" stroke={accentSoft} strokeWidth="3" strokeLinecap="round" />
      <path d="M-26 18 C -14 24, 14 24, 26 18" stroke="#7A3B00" strokeWidth="2" strokeLinecap="round" opacity="0.45" />
      <path d="M36 6 L50 0 L44 10 Z" fill={accent} />
      <g className="pb-offer-flame">
        <path d="M0 2 C -11 -10, -6 -26, 0 -40 C 6 -26, 11 -10, 0 2 Z" fill="#FF9F1C" />
        <path d="M0 0 C -5 -8, -3 -18, 0 -26 C 3 -18, 5 -8, 0 0 Z" fill="#FFF3B0" />
      </g>
    </g>

    {/* Sparkles */}
    <Sparkle x={20} y={24} size={6} delay="0s" color={accentSoft} />
    <Sparkle x={112} y={20} size={5} delay="0.9s" color={accentSoft} />
    <Sparkle x={206} y={30} size={7} delay="1.6s" color={accent} />
    <Sparkle x={196} y={140} size={5} delay="0.5s" color={accentSoft} />
    <Sparkle x={108} y={146} size={4} delay="2.1s" color={accent} />
  </svg>
);

const ARTWORK_BY_THEME = {
  diwali: DiyaRangoliArtwork,
};

const OfferArtwork = ({ theme, className = "" }) => {
  const Artwork = ARTWORK_BY_THEME[theme?.artwork];
  if (!Artwork) return null;

  return (
    <div className={className} aria-hidden="true">
      <Artwork accent={theme.accent} accentSoft={theme.accentSoft} />
    </div>
  );
};

export default OfferArtwork;
